import { gql } from '@apollo/client';

export const GQL_GET_PLAYER = gql`
  query GET_PLAYER($playerId: ID!) {
    player(id: $playerId) {
      id
      name
      camera {
        id
        name
        longitude
        latitude
        timezone
        timezoneAsPack
        record {
          fastPlaybacks {
            speed
          }
        }
        frameCaptures {
          captures {
            ref
          }
        }
        panoramas {
          ref
        }
        client {
          id
          name
        }
        server {
          subdomain
        }
      }
      active
      type
      settings
      allowedDomains
    }
  }
`;
